import { keyframes, styled } from "@mui/material";
const loadAnimation = keyframes`
  from {
    left: var(--startPosition);
  }
  65% {
    left: 100%;
  }
  100% {
    left: var(--startPosition);
  }
`;
const Root = styled("div", {
  skipSx: true,
  name: "SuperCarIndicator",
  slot: "Root"
})`
  animation: ${loadAnimation} infinite var(--duration, 3s);
  background: var(--color);
  position: absolute;
  width: var(--size);
  z-index: 10;
  height: 4px;
  left: 0;
  top: 0;
`;
export {
  Root
};
//# sourceMappingURL=Root.js.map
